module.exports = __webpack_public_path__ + "img/39_31.58c34ce0.png";